// react-bootstrap imports
import { useEffect, useState } from "react"
// import { Button } from "react-bootstrap"

// service imports
import { asBRL } from "services/CalcTaxaFunctions"
import * as service from "services/Gestao/Levantamento"

import * as Links from "constants/links"
import { useNavigate } from "react-router-dom"
import { ROLE } from "constants/userRoles"

// chart imports
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2"
import { userHasAccess, userLogado } from "services/LoginFunctions";

const docLabels =
[
    "Alv. Uni.",
    "Alv. Multi. Hor.",
    "Alv. Multi. Ver.",
    "Alv. Nao Res.",
    "Alv. Lot.",
    "Anu. Uni.",
    "Anu. Multi. Hor.",
    "Anu. Multi. Ver.",
    "Anu. Nao Res.",
    "Anu. Lot.",
    "Aut. Demol",
    "Aut. ERB",
    "Aut. Obras Infra",
    "Aut. Rep. Gerais",
    "Aut. Rep. Gerais Acess.",
    "Cert. Regul.",
    "Cert. Laudo Vist.",
    "Cert. Regul. Infra",
    "Cert. Uso Ocup. Solo",
    "Cert. Uso Ocup. Solo Dir.",
    "Decl. Atend. Termo Compr",
    "Decl. Conc. Obras Infra",
    "Decl. GLP",
    "Decl. Inst. ERB",
    "Decl. Num. Porta",
    "Decl. Rep. Gerais Acess.",
    "Decl. Rep. Gerais",
    "Dir. Drenagem",
    "Habite-se",
    "Termo. Demarc.",
    "Termo. Desm. Gleba",
    "Termo. Desm. Lote",
    "Termo. Rem.",
    "Termo. Rem. Desm.",
    "Guia Pag. Aut. Obras Infra",
    "Guia. Pag",
    "Multa"
]

const BarChart = ({ labels, values, title, fullWidth = false }) =>
{
    if (!labels || !values) { console.log("Erro ao plotar gráfico. Labels ou valores indefinidos") ; return <></>}
    if (labels.length <= 0 || values.length <= 0) { console.log("Erro ao plotar gráfico. Não tem labels ou valores") ; return <></>}
    if (labels.length !== values.length) { console.log("Erro ao plotar gráfico. Qtd de labels diferente da qtd de valores") ; return <></>}

    const options =
    {
        responsive: true,
        maintainAspectRatio: false,
        plugins:
        {
            legend: { display: false, position: "top" },
            title: { display: true, text: title }
        }
    }
    const data =
    {
        labels,
        datasets:
        [
          {
            label: title,
            data: values,
            backgroundColor: 'rgba(0, 60, 200, 0.8)'
          },
        //   {
        //     label: 'Dataset 2',
        //     data: ["20","0"],
        //     backgroundColor: 'rgba(53, 162, 235, 0.5)'
        //   }
        ]
    }
    
    ChartJS.register( CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend )
    
    return (
        <div className={"m-2" + (fullWidth ? " w-100" : "")}>
            <Bar options={options} data={data} />
        </div>
    )
}

const Info = ({ label, value }) =>
{
    return (
        <div>
            <p className="fw-bold text-center mb-1">Resumo</p>
            <hr className="text-primary opacity-100 mt-0" />
            <p><b>{label}{": "}</b>{value}</p>
        </div>
    )
}

const PainelResumos = () =>
{
    const [arrecadado, setArrecadado] = useState(0)

    useEffect(() => {
        async function fecthData()
        {
            setArrecadado(await service.ValorArrecadacaoMensal())
        }
        fecthData()
    }, []);
    
    return (
        <div className="container col-md-auto bg-white border border-dark rounded-5 mx-3 mb-3 pt-3 shadow">
            <Info label={"Arrecadação mensal"} value={asBRL(arrecadado)} />
        </div>
    )
}

const PainelGraficos = () =>
{
    const [charts, setCharts] = useState({})

    useEffect(() => {
        async function fecthData()
        {
            setCharts({...charts, qtdPorTipo: await service.ChartDocsPorTipo(), qtdPorDia: await service.ChartDocsPorDia()}) ;
            
        }
        fecthData()
    }, []);

    const docsPorTipoLabels = charts.qtdPorTipo?.labels.map(tipoDocID => docLabels[Number(tipoDocID)])

    return (
        <div className="col-md-auto bg-white border border-dark rounded-5 mb-3 shadow">
            <div className="d-flex" style={{"minHeight": "270px", "minWidth": "1000px"}} >
                <BarChart labels={docsPorTipoLabels} values={charts.qtdPorTipo?.values} title={charts.qtdPorTipo?.title} fullWidth={true} />
            </div>
            <div className="d-flex">
                <BarChart labels={charts.qtdPorDia?.labels} values={charts.qtdPorDia?.values} title={charts.qtdPorDia?.title} fullWidth={false} />
            </div>
        </div>
    )
}
export const LevantamentosScreen = ({ listaProcessos }) =>
{
    const navigate = useNavigate()
    if (!userLogado) { navigate(Links.SEM_PERMISSAO) }
    if (!userHasAccess(ROLE.GESTOR)) { navigate(Links.SEM_PERMISSAO) }

    return (
        <div className="d-flex m-auto">
            <PainelResumos />
            <PainelGraficos />
        </div>
    )
}
